export default {
  methods: {
    /**
     * Validates that this.content contains a valid script string
     * @returns {boolean} True if content is valid, false otherwise
     */
    checkScript() {
      if (this.isValidScript(this.data.content)) {
        this.$notification.success("Script is valid.")
      } else {
        this.$notification.danger("Script is invalid.")
      }
    },

    /**
     * Validates that this.content contains a valid script string
     * @returns {boolean} True if content is valid, false otherwise
     */
    isValidScript(scriptCode) {
      try {
        new Function(scriptCode)

        return true
      } catch (e) {
        if (e instanceof SyntaxError) {
          console.error("Syntax Error:", e.message)
          return false // Syntax is invalid
        }
        // Other errors might occur, but SyntaxError is what you're looking for.
        return false
      }
    },

    /**
     * Validates that this.content contains a valid style string
     * @returns {boolean} True if content is valid, false otherwise
     */
    checkStyles() {
      if (this.isValidCssStylesheet(this.data.content)) {
        this.$notification.success("CSS is valid.")
      } else {
        this.$notification.danger("CSS is invalid.")
      }
    },

    /**
     * Is the CSS input valid?
     *
     * @param {string} cssInput
     * @returns {boolean} True if CSS is valid, false otherwise
     */
    isValidCssStylesheet(cssInput) {
      // 1. Create a temporary <style> element
      const styleElement = document.createElement("style")
      styleElement.textContent = cssInput

      // 2. Temporarily append it to the document (must be in the DOM to get a stylesheet object in some browsers)
      document.head.appendChild(styleElement)

      let isValid = false
      let styleSheet = null

      try {
        // 3. Get the CSSStyleSheet object
        // The browser parses the CSS text when it's added to the DOM and creates the stylesheet object.
        styleSheet = styleElement.sheet

        // 4. Check if the stylesheet object exists and contains any rules
        // If the CSS is syntactically invalid (e.g., missing a brace, bad property),
        // the browser often fails to create a sheet or populates it with zero rules.
        if (styleSheet && styleSheet.cssRules && styleSheet.cssRules.length > 0) {
          isValid = true
        } else if (styleSheet && cssInput.trim() === "") {
          // Handle the case where the input is valid but empty
          isValid = true
        }
      } catch (error) {
        // Catch potential errors during sheet access (e.g., security errors with cross-origin rules)
        console.error("Error accessing stylesheet rules:", error)
        isValid = false
      } finally {
        // 5. Clean up by removing the temporary <style> element
        if (styleElement.parentNode) {
          styleElement.parentNode.removeChild(styleElement)
        }
      }

      return isValid
    }
  }
}
